<template id="top">
  <div class="has-text-weight-bold">
    <div class="hero">
      <div class="hero-body">
        <!-- フローティング要素 -->
        <div class="floating-elements">
          <div class="floating-circle floating-circle-1"></div>
          <div class="floating-circle floating-circle-2"></div>
          <div class="floating-circle floating-circle-3"></div>
        </div>

        <!-- PC -->
        <div v-if="!$isMobile()" class="hero-content">
          <div class="columns is-vcentered">
            <div class="column is-6">
              <div class="hero-text-wrapper">
                <div class="hero-badge">
                  <span class="badge-icon">🚀</span>
                  <span class="badge-text">100GBまで無料</span>
                </div>
                <h1 class="hero-title-text">
                  <span class="gradient-text">{{ $t('top.hero.gradient') }}</span><br>
                  <span>{{ $t('top.hero.normal') }}</span>
                </h1>
                <p class="hero-subtitle">{{ $t('top.catch') }}</p>

                <!-- 統計情報カード -->
                <div class="stats-container">
                  <div class="stat-card">
                    <div class="stat-number">{{ companyCount }}</div>
                    <div class="stat-label">導入企業数</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-number">0</div>
                    <div class="stat-label">セキュリティ事故</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-number">99.9%</div>
                    <div class="stat-label">稼働率</div>
                  </div>
                </div>

                <div class="hero-actions">
                  <ButtonSignUp class="button-elevated" />
                  <ButtonLogin class="button-secondary" />
                  <ButtonDashboard />
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="hero-image-wrapper">
                <div class="hero-image-bg"></div>
                <picture class="hero-image">
                  <source srcset="/static/images/logo-512x512.avif" type="image/avif">
                  <img src="/static/images/logo-512x512.avif" loading="eager" alt="HStorage ロゴ" width="512"
                    height="512">
                </picture>
              </div>
            </div>
          </div>
        </div>

        <!-- SP -->
        <div v-else class="hero-content-mobile">
          <div class="hero-badge-mobile">
            <span class="badge-icon">🚀</span>
            <span class="badge-text">100GBまで無料</span>
          </div>

          <div class="hero-image-wrapper-mobile">
            <img srcset="/static/images/logo-256x256.avif 256w, /static/images/logo-512x512.avif 512w"
              sizes="(max-width: 640px) 256px, 512px" src="/static/images/logo-512x512.avif" loading="eager"
              alt="HStorage ロゴ" width="512" height="512" class="hero-image-mobile" />
          </div>

          <h1 class="hero-title-text-mobile">
            <span class="gradient-text">{{ $t('top.hero.gradient') }}</span><br>
            <span>{{ $t('top.hero.normal') }}</span>
          </h1>
          <p class="hero-subtitle-mobile">{{ $t('top.catch') }}</p>

          <div class="stats-container-mobile">
            <div class="stat-card-mobile">
              <div class="stat-number">{{ companyCount }}</div>
              <div class="stat-label">導入企業</div>
            </div>
            <div class="stat-card-mobile">
              <div class="stat-number">0</div>
              <div class="stat-label">事故件数</div>
            </div>
            <div class="stat-card-mobile">
              <div class="stat-number">99.9%</div>
              <div class="stat-label">稼働率</div>
            </div>
          </div>

          <div class="hero-actions-mobile">
            <ButtonSignUp class="button-elevated-mobile" />
            <ButtonDashboard v-if="!$store.state.isLoggedIn" class="button-secondary-mobile" />
          </div>
        </div>

        <!-- お試しアップロードボタン -->
        <div v-if="!$store.state.isLoggedIn" class="trial-upload-wrapper">
          <b-button class="button trial-upload-button" icon-pack="fas" icon-right="rocket" rounded
            @click="openTrialModal">
            <div>
              <span class="trial-text">お試しアップロード</span>
              <span class="trial-subtext">登録不要・無料</span>
            </div>
          </b-button>
          <b-modal v-model="openModal" aria-role="dialog" aria-label="HStorage ゲストアップロード" aria-modal :can-cancel="true">
            <template #default="props">
              <div @close="props.close" class="my-modal">
                <h3>
                  <span class="section-title">＼ お試しアップロード ／</span>
                </h3>
                <div>
                  <p class="margin-bottom-12px">下記の制限がありますがユーザー登録（無料）せずに HStorage をお試しいただけます！</p>
                  <p>■ 最大 100GB までのアップロード</p>
                  <p>■ ファイルの保存期間は7日間まで</p>
                </div>
                <UploadComponent :is-guest="true" />
              </div>
            </template>
          </b-modal>
        </div>
      </div>
    </div>

    <section class="section">
      <p>＼ 45秒 CM動画をみる ／</p>
      <a href="https://www.youtube.com/watch?v=cv5kKIzZs3U" rel="noreferrer" target="_blank">
        <picture>
          <source media="(max-width:520px)" srcset="/static/images/cm.webp 1920w" sizes="10vw">
          <source srcset="/static/images/cm.webp 1920w" sizes="(max-width:1280px) 50vw">
          <img class="cm" src="/static/images/cm.webp" draggable="false" width="640" height="360"
            alt="クラウドストレージ HStorage CM動画">
        </picture>
      </a>
    </section>

    <div class="margin-top-30px margin-bottom-30px">
      <p>{{ $t('top.count.1') }} <br class="is-hidden-desktop"><span class="count">
          <count-up :startVal="0" :endVal="this.$store.state.init['data_usage_info'].count" :delay="count.delay"
            :options="count.options" @ready="countOnReady" />
        </span>{{ $t('top.count.2') }}
      </p>
    </div>

    <AppLinks :isCenter="true" :isDark="false"></AppLinks>

    <div class="margin-top-30px">
      <a href="https://www.itreview.jp/products/hstorage/profile#scroll" rel="noreferer" target="_blank">
        <picture>
          <source srcset="/static/images/itreview-half.webp" media="(max-width: 640px)" type="image/webp">
          <img src="/static/images/itreview.png" loading="lazy" alt="ITReview ロゴ" width="135">
        </picture>
      </a>
    </div>

    <div class="margin-top-30px margin-bottom-30px">
      <div class="has-text-grey has-text-normal">
        <marquee-text :repeat="5" :duration="60">
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.lycorp.co.jp/ja/" rel="noreferer"
              target="_blank">LINEヤフー株式会社</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://meldia.co.jp/" rel="noreferer" target="_blank">株式会社メルディア
              三栄建築設計</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.osakac.ac.jp/corp/" rel="noreferer" target="_blank">学校法人
              大阪電気通信大学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.a-too.co.jp/ja" rel="noreferer" target="_blank">株式会社 エーツー
              駿河屋</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.hot-cha.tv/" rel="noreferer"
              target="_blank">長門市ケーブルテレビ</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://jtrustc.co.jp/" rel="noreferer" target="_blank">株式会社
              インターネットプライバシー研究所</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.kk-daiwakagaku.co.jp/" rel="noreferer" target="_blank">株式会社
              ダイワ化学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://shizuoka.kufu.company/" rel="noreferer" target="_blank">株式会社
              しずおかオンライン</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://sig-co.com/" rel="noreferer" target="_blank">株式会社 SIG</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://adnest.co.jp/" rel="noreferer" target="_blank">株式会社
              アドネスト</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.mynet.co.jp/" rel="noreferer" target="_blank">株式会社
              マイネット</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.imagicalab.co.jp/" rel="noreferer" target="_blank">株式会社
              IMAGICA
              Lab.</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.tohoku.ac.jp/japanese/" rel="noreferer" target="_blank">国立大学法人
              東北大学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.chiba-u.ac.jp/" rel="noreferer" target="_blank">国立大学法人
              千葉大学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.hokudai.ac.jp/" rel="noreferer" target="_blank">国立大学法人
              北海道大学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.ikuei.ed.jp/" rel="noreferer" target="_blank">学校法人
              奈良育英学園</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.n-fukushi.ac.jp/" rel="noreferer" target="_blank">学校法人
              日本福祉大学</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.heisei-iryo.ac.jp/" rel="noreferer" target="_blank">学校法人
              平成医療学園</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://www.jages.net/HOME/" rel="noreferer" target="_blank">一般社団法人
              日本老年学的評価機構</a></span>
          <span class="marquee-text-margin">
            <a class="has-text-normal" href="https://toshimamura-csw.main.jp/" rel="noreferer" target="_blank">社会福祉法人
              利島村社会福祉協議会</a></span>
        </marquee-text>
      </div>
      <div>
        <p class="has-text-grey" style="font-size:12px">他60社以上 2024/08/0 更新</p>
      </div>
    </div>

    <section class="section" id="benefits">
      <h2 class="margin-bottom-30px">
        <span class="section-title">Benefits</span>
        <span class="section-description">選ばれる理由</span>
      </h2>
      <p class="margin-bottom-30px">HStorage は単なるクラウドストレージではなく、ビジネスの成功に不可欠なツールです</p>

      <div class="columns is-multiline margin-bottom-60px">
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'shield-alt']" size="3x" />
            </div>
            <h3 class="benefit-title">セキュリティ最優先</h3>
            <p>業界最高水準の暗号化とウイルスチェックを標準装備。機密データも安心して保存できます。</p>
          </div>
        </div>
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'bolt']" size="3x" />
            </div>
            <h3 class="benefit-title">驚異的な処理速度</h3>
            <p>独自の最適化技術により、大容量ファイルでも驚くほど高速な転送速度を実現します。</p>
          </div>
        </div>
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'coins']" size="3x" />
            </div>
            <h3 class="benefit-title">コスト削減効果</h3>
            <p>従来のストレージ比で最大60%のコスト削減が可能。無駄な支出を抑えます。</p>
          </div>
        </div>
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'users']" size="3x" />
            </div>
            <h3 class="benefit-title">チーム連携強化</h3>
            <p>直感的な共有機能でチームワークを加速。複雑な設定は一切不要です。</p>
          </div>
        </div>
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'cogs']" size="3x" />
            </div>
            <h3 class="benefit-title">豊富な連携機能</h3>
            <p>主要サービスとシームレスに連携。既存のワークフローを変更する必要はありません。</p>
          </div>
        </div>
        <div class="column is-4">
          <div class="benefit-box">
            <div class="benefit-icon">
              <font-awesome-icon :icon="['fas', 'headset']" size="3x" />
            </div>
            <h3 class="benefit-title">充実サポート体制</h3>
            <p>日本語ネイティブのサポートチームが最短1時間以内に対応。安心してご利用いただけます。</p>
          </div>
        </div>
      </div>
    </section>

    <div class="cta-banner margin-bottom-60px">
      <div class="cta-content">
        <h3 class="cta-title">今すぐ HStorage を体験しませんか？</h3>
        <p class="cta-text">無料でスタート。クレジットカードの登録は不要です。</p>
        <div class="cta-buttons margin-top-24px">
          <ButtonSignUp />
          <b-button class="button is-info is-focused has-text-weight-bold margin-left-12px" icon-pack="fas"
            icon-right="rocket" rounded @click="openModal = true">
            お試しアップロード
          </b-button>
        </div>
      </div>
    </div>

    <section class="section" id="tokutyou">
      <h2 class="margin-bottom-30px">
        <span class="section-title">Service</span>
        <span class="section-description" v-html="$t('top.tokutyou.title')" />
      </h2>
      <div class="margin-bottom-30px">
        <img srcset="/static/images/header-320.avif 320w,
             /static/images/header-640.avif 640w,
             /static/images/header-1024.avif 1024w,
             /static/images/header-1280.avif 1280w" sizes="(max-width: 320px) 320px,
            (max-width: 640px) 640px,
            (max-width: 1024px) 1024px,
            1280px" src="https://hstorage.io/static/images/header-1280.avif" alt="HStorage ヘッダー画像" width="1280"
          height="1280">
      </div>
      <p class="margin-bottom-60px" v-html="$t('top.tokutyou.description')" />
      <div class="margin-bottom-60px">
        <p class="rainbow tokutyou-number">200,000+</p>
        <p class="margin-bottom-6px">月間訪問者数</p>
        <p>
          HStorageはファイルのアップロード・管理・ダウンロード・動画の再生のため、世界から月20万人以上に訪問されています。</p>
      </div>
      <div class="margin-bottom-60px">
        <p class="rainbow tokutyou-number">35,000,000+ <span>20TB+</span></p>
        <p class="margin-bottom-6px">月間ファイル送信数</p>
        <p>HStorageはクラウドストレージとして月に3,500万回以上のファイルを送信し、その容量は20TBを超えています。</p>
      </div>
      <div class="margin-bottom-60px">
        <p class="rainbow tokutyou-number">0</p>
        <p class="margin-bottom-6px">セキュリティ事故</p>
        <p>HStorageのセキュリティ事故は未だゼロです。クラウドストレージではセキュリティがもっとも大事です。</p>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent is-12">
          <div class="tile is-child box">
            <div class="columns">
              <div class="column has-text-left card-padding-mobile card-padding">
                <h3 class="title" v-html="$t('top.card.security.title')" />
                <p v-html="$t('top.card.security.description')" style="margin-bottom:1.5rem" />
                <router-link to="/about/security" class="has-text-primary">
                  <p>{{ $t('top.card.security.link') }}
                    <img src="/static/images/icons/chevron-right-solid.svg" draggable="false" alt="arrow right"
                      width="8px" height="12.8">
                  </p>
                </router-link>
              </div>
              <div class="column security-background" v-lazy:background-image="bg_image_security" />
            </div>
          </div>
        </div>
      </div>

      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <div class="tile is-child box card-padding">
            <h3 class="title" v-html="$t('top.card.free.title')"></h3>
            <p v-html="$t('top.card.free.description')"></p>
            <br class="is-hidden-mobile">
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box card-padding card-padding">
            <h3 class="title" v-html="$t('top.card.direct.title')"></h3>
            <p v-html="$t('top.card.direct.description')"></p>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box card-padding card-padding">
            <h3 class="title" v-html="$t('top.card.network.title')"></h3>
            <p v-html="$t('top.card.network.description')"></p>
          </div>
        </div>
      </div>

      <div class="tile is-ancestor">
        <div class="tile is-parent is-12">
          <div class="tile is-child box">
            <div class="columns">
              <div class="column has-text-left card-padding-mobile card-padding">
                <h3 class="title" v-html="$t('top.card.dashboard.title')" />
                <p v-html="$t('top.card.dashboard.description')" style="margin-bottom:1.5rem" />
                <router-link to="/about/dashboard" class="has-text-primary">
                  <p>{{ $t('top.card.dashboard.link') }}
                    <img src="/static/images/icons/chevron-right-solid.svg" draggable="false" alt="arrow right"
                      width="8px" height="12.8">
                  </p>
                </router-link>
              </div>
              <div class="column dashboard-background" v-lazy:background-image="bg_image_dashboard"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="features">
      <h2 class="margin-bottom-30px">
        <span class="section-title">Features</span>
        <span class="section-description" v-html="$t('top.features.title')" />
      </h2>
      <p class="margin-bottom-60px" v-html="$t('top.features.description')" />

      <div class="tile is-ancestor">
        <div class="tile is-3 is-vertical is-parent">
          <div class="tile is-child is-child-center box tile-card-100gb">
            <p class="tokutyou-number" v-html="$t('top.card.upload')"></p>
          </div>
          <div class="tile is-child is-child-center box tile-card-direct">
            <p class="rainbow" style="font-size:2.6em">FTPクライアント対応</p>
          </div>
        </div>
        <div class="tile is-vertical is-parent">
          <div class="tile is-child box">
            <p class="title">{{ $t('top.card.download.download') }}</p>
            <div class="columns">
              <div class="column">
                <p>直リンク</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'link']" size="4x" />
                </div>
              </div>
              <div class="column">
                <p>{{ $t('top.card.download.count') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'arrow-down-wide-short']" size="4x" />
                </div>
              </div>
              <div class="column">
                <p>{{ $t('top.card.download.limit_date') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'calendar-days']" size="4x" />
                </div>
              </div>
              <div class="column">
                <p>{{ $t('top.card.download.password') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'key']" size="4x" />
                </div>
              </div>
              <div class="column">
                <p>{{ $t('top.card.download.encrypt') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'microchip']" size="4x" />
                </div>
              </div>
            </div>
          </div>
          <div class="tile is-child box">
            <img src="/static/images/top-card-ogp.avif" width="640" height="336" loading="lazy" alt="TOPページ ヘッダー画像">
          </div>
        </div>
        <div class="tile is-3 is-vertical is-parent">
          <div class="tile is-child is-child-center box tile-card-infinite">
            <p style="font-size:3em">{{ $t('top.card.infinite.storage') }}</p>
          </div>
          <div class="tile is-child is-child-center box tile-card-infinite">
            <p style="font-size:3em">{{ $t('top.card.infinite.count') }}</p>
          </div>
        </div>
      </div>

      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ $t('top.card.processing') }}</p>
            <font-awesome-icon :icon="['fas', 'microchip']" size="5x" />
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ $t('top.card.group') }}</p>
            <font-awesome-icon :icon="['fas', 'layer-group']" size="4x" />
          </article>
        </div>
      </div>

      <div class="tile is-ancestor has-text-white">
        <div class="tile is-parent">
          <div class="tile is-child box tile-card-security">
            <p class="title has-text-white">{{ $t('top.card.tile.security.title') }}</p>
            <div class="columns">
              <div class="column">
                <p>{{ $t('top.card.tile.security.encrypt.title') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'microchip']" size="4x" />
                </div>
                <p v-html="$t('top.card.tile.security.encrypt.desc')"></p>
              </div>
              <div class="column">
                <p>{{ $t('top.card.tile.security.virus.title') }}</p>
                <div class="top-card-icon">
                  <font-awesome-icon :icon="['fas', 'shield']" size="4x" />
                </div>
                <p v-html="$t('top.card.tile.security.virus.desc')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="blog">
      <h2 class="margin-bottom-30px">
        <span class="section-title">Update</span>
        <span class="section-description" v-html="$t('top.update.title')" />
      </h2>
      <p class="margin-bottom-60px" v-html="$t('top.update.description')" />

      <div class="tile is-ancestor">
        <div class="tile is-parent" v-for="post in rss.posts" :key="post.index">
          <div class="tile is-child box card-padding">
            <a :href="post.url + '?utm_source=hstorage'" rel="noreferrer">
              <img :src="post.cover" class="image" style="margin: 0 auto;width: 256px;height: 180px;border-radius:30px"
                loading="lazy" alt="HStorage ブログ サムネイル" />
              <p class="has-text-normal margin-top-12px">
                <strong>{{ post.title }}</strong>
                <br>
                <small class="has-text-grey">{{ post.date }}</small>
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="testimonials">
      <h2 class="margin-bottom-30px">
        <span class="section-title">Testimonials</span>
        <span class="section-description">お客様の声</span>
      </h2>
      <p class="margin-bottom-60px">多くの企業様にご愛顧いただいています</p>

      <div class="columns is-multiline">
        <div class="column is-4">
          <div class="testimonial-box">
            <div class="testimonial-content">
              <p class="testimonial-text">「HStorageの導入により、社内のファイル共有業務が劇的に効率化しました。特にセキュリティ面での安心感は他のサービスでは得られません。」</p>
            </div>
            <div class="testimonial-author">
              <img src="/static/images/testimonial-1.avif" alt="IT企業 CIO" class="testimonial-avatar" width="50"
                height="50">
              <div class="testimonial-info">
                <p class="testimonial-name">鈴木 健太郎 様</p>
                <p class="testimonial-position">大手IT企業 CIO</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="testimonial-box">
            <div class="testimonial-content">
              <p class="testimonial-text">「大容量ファイルの転送に悩んでいましたが、HStorageを使うことで問題が解決しました。今では社内標準ツールとして全部署で利用しています。」</p>
            </div>
            <div class="testimonial-author">
              <img src="/static/images/testimonial-2.avif" alt="製造業 部長" class="testimonial-avatar" width="50"
                height="50">
              <div class="testimonial-info">
                <p class="testimonial-name">田中 優子 様</p>
                <p class="testimonial-position">製造業 情報システム部長</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="testimonial-box">
            <div class="testimonial-content">
              <p class="testimonial-text">「クライアントとの大容量データのやり取りが多い業種ですが、HStorageのおかげで業務効率が50%以上改善しました。サポートの手厚さも魅力です。」</p>
            </div>
            <div class="testimonial-author">
              <img src="/static/images/testimonial-3.avif" alt="デザイン会社 代表" class="testimonial-avatar" width="50"
                height="50">
              <div class="testimonial-info">
                <p class="testimonial-name">佐藤 一郎 様</p>
                <p class="testimonial-position">デザイン会社 代表取締役</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="faq">
      <h2 class="margin-bottom-30px">
        <span class="section-title">FAQ</span>
        <span class="section-description">よくある質問</span>
      </h2>
      <p class="margin-bottom-60px">HStorageに関するよくある質問にお答えします</p>

      <div class="faq-container">
        <div class="faq-item">
          <div class="faq-question" @click="toggleFaq(0)">
            <h3>無料プランでも商用利用できますか？</h3>
            <span class="faq-icon">{{ faqOpen.faq0 ? '−' : '＋' }}</span>
          </div>
          <div class="faq-answer" v-if="faqOpen.faq0">
            <p>はい、無料プランでも商用利用可能です。容量制限やアップロード回数に制限がありますが、ビジネスでもご利用いただけます。より大容量・高機能が必要な場合はプレミアムプランをご検討ください。</p>
          </div>
        </div>
        <div class="faq-item">
          <div class="faq-question" @click="toggleFaq(1)">
            <h3>ファイルのセキュリティはどのように確保されていますか？</h3>
            <span class="faq-icon">{{ faqOpen.faq1 ? '−' : '＋' }}</span>
          </div>
          <div class="faq-answer" v-if="faqOpen.faq1">
            <p>
              HStorageでは、AES-256bit暗号化、SSLによる通信暗号化、マルウェアスキャン、アクセス制限など複数のセキュリティ対策を導入しています。また、SOC2およびISMS（ISO27001）に準拠したセキュリティ管理体制を整えています。
            </p>
          </div>
        </div>
        <div class="faq-item">
          <div class="faq-question" @click="toggleFaq(2)">
            <h3>プレミアムプランとビジネスプランの違いは何ですか？</h3>
            <span class="faq-icon">{{ faqOpen.faq2 ? '−' : '＋' }}</span>
          </div>
          <div class="faq-answer" v-if="faqOpen.faq2">
            <p>
              プレミアムプランは個人や小規模チーム向けで、容量とアップロード回数が増加します。ビジネスプランはチーム管理機能、高度なアクセス権限設定、API連携、専用サポートなどの企業向け機能が追加されます。詳しくは料金プランページをご覧ください。
            </p>
          </div>
        </div>
        <div class="faq-item">
          <div class="faq-question" @click="toggleFaq(3)">
            <h3>対応しているファイル形式に制限はありますか？</h3>
            <span class="faq-icon">{{ faqOpen.faq3 ? '−' : '＋' }}</span>
          </div>
          <div class="faq-answer" v-if="faqOpen.faq3">
            <p>
              HStorageはあらゆるファイル形式に対応しています。動画、音声、画像、文書、圧縮ファイルなど、業務で使用されるほぼすべての形式のファイルをアップロードいただけます。ただし、マルウェアと判定されたファイルはブロックされます。
            </p>
          </div>
        </div>
        <div class="faq-item">
          <div class="faq-question" @click="toggleFaq(4)">
            <h3>法人として導入を検討しています。問い合わせ先を教えてください。</h3>
            <span class="faq-icon">{{ faqOpen.faq4 ? '−' : '＋' }}</span>
          </div>
          <div class="faq-answer" v-if="faqOpen.faq4">
            <p>法人導入のご相談は、お問い合わせページからご連絡いただくか、contact@hstorage.io までメールにてお問い合わせください。専任の担当者がご要望に合わせたプランをご提案いたします。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- https://github.com/FortAwesome/Font-Awesome/issues/11925#issuecomment-393975346 -->
    <svg width="0" height="0">
      <radialGradient id="lgrad" cx="50%" cy="50%" r="50%">
        <stop offset="0%" style="stop-color:rgb(238,53,115);stop-opacity:1.00" />
        <stop offset="50%" style="stop-color:rgb(73,116,187);stop-opacity:1.00" />
        <stop offset="100%" style="stop-color:rgb(249,182,77);stop-opacity:1.00" />
      </radialGradient>
    </svg>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useHead } from '@unhead/vue'
import { defineAsyncComponent } from "vue";

import CountUp from 'vue-countup-v3'
import ButtonSignUp from "../components/ButtonSignUp.vue";
import ButtonDashboard from "../components/ButtonDashboard.vue";
import ButtonLogin from "../components/ButtonLogin.vue";
import AppLinks from "../components/AppLinks.vue";

document.addEventListener("DOMContentLoaded", function () {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});

export default {
  name: "TOP",
  components: {
    UploadComponent: defineAsyncComponent(() => import('../components/dashboard/UploadComponent.vue')),
    AppLinks,
    CountUp,
    ButtonLogin, ButtonDashboard, ButtonSignUp
  },
  data() {
    return {
      openModal: false,
      bg_image_dashboard: '/static/images/card_dashboard.webp',
      bg_image_security: '/static/images/card_security.webp',
      // 導入企業数を一元管理（PC版とモバイル版で共通使用）
      companyCount: '300+',
      rss: {
        feedUrl: "https://hstorage.io/blog/feed.json",
        posts: [],
      },
      count: {
        delay: 2000,
        options: {
          useEasing: true,
          useGrouping: true,
          duration: 3,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        }
      },
      faqOpen: {
        faq0: false,
        faq1: false,
        faq2: false,
        faq3: false,
        faq4: false
      }
    }
  },
  async created() {
    useHead({
      title: `${this.$t('top.top')} | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        { name: 'description', content: appConfig[this.$i18n.locale].description.top },
        { name: 'keywords', content: 'クラウドストレージ,ファイル転送,大容量ファイル,セキュリティ,オンラインストレージ,ファイル共有,ビジネス向け' }
      ],
      link: [
        { rel: 'canonical', href: 'https://hstorage.io' },
      ]
    })

    const login = this.$route.query.login
    if (login) {
      await this.WaitingAuth0()
    }

    if (this.$route.query.is_deleted === 'true') {
      this.toastInfo(this.$t('top.deleted'))
    }

    this.$axios.get(this.rss.feedUrl).then(resp => {
      const items = resp.data.items

      items.forEach((item, index) => {
        // 3件だけ表示する
        if (index >= 3) {
          return
        }

        const dateStr = resp.data.items[0]['date_published']
        const date = new Date(dateStr);
        const yyyy = date.getFullYear()
        const mm = date.getMonth()
        const dd = date.getDate()

        this.rss.posts.push({
          index: index,
          title: item.title,
          url: item.url,
          cover: item.cover,
          date: `${yyyy}/${mm}/${dd}`
        })
      })
    })
  },
  methods: {
    async prefetchUploadComponent() {
      try {
        await import('../components/dashboard/UploadComponent.vue')
      } catch (e) {
        // 事前読み込みに失敗しても致命的ではない
        console.warn('prefetch UploadComponent failed', e)
      }
    },
    async openTrialModal() {
      await this.prefetchUploadComponent()
      this.openModal = true
    }
  },
  methods: {
    countOnReady: function (instance, CountUp) {
      instance.update(this.$store.state.init['data_usage_info'].count);
    },
    toggleFaq: function (index) {
      const key = `faq${index}`;
      this.faqOpen[key] = !this.faqOpen[key];
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  background: linear-gradient(135deg, rgba(242, 67, 104, 0.05) 0%, rgba(73, 116, 187, 0.05) 50%, rgba(249, 182, 77, 0.05) 100%);
  position: relative;
  overflow: hidden;
  min-height: 85vh;
  display: flex;
  align-items: center;
}

.hero-body {
  padding: 2rem 1rem;
  position: relative;
  width: 100%;
  z-index: 1;
}

// フローティング要素
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.floating-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
  animation: float 20s infinite ease-in-out;
}

.floating-circle-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #F24368, #F9B64D);
  top: 10%;
  left: -5%;
  animation-delay: 0s;
}

.floating-circle-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #4974BB, #F24368);
  top: 50%;
  right: -5%;
  animation-delay: 5s;
}

.floating-circle-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #F9B64D, #4974BB);
  bottom: 10%;
  left: 50%;
  animation-delay: 10s;
}

// グラデーションテキスト用のクラス
.gradient-text {
  background: linear-gradient(to right, #5AB0E3, #4672B8);
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}

@keyframes float {

  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }

  33% {
    transform: translate(30px, -30px) rotate(120deg);
  }

  66% {
    transform: translate(-20px, 20px) rotate(240deg);
  }
}

// PC版スタイル
.hero-content {
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
}

.hero-text-wrapper {
  padding: 2rem 0;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(242, 67, 104, 0.1);
  border: 1px solid rgba(242, 67, 104, 0.2);
  border-radius: 24px;
  padding: 0.5rem 1rem;
  margin-bottom: 1.5rem;
  animation: pulse 2s infinite;
}

.badge-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.badge-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #F24368;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.hero-title-text {
  font-size: 2.8rem;
  font-weight: 900;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #18181B 0%, #18181B 40%, #F24368 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.3rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
}

// 統計情報カード
.stats-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  flex: 1;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.stat-number {
  font-size: 2rem;
  font-weight: 800;
  color: #F24368;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
}

// ボタンスタイル
.hero-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.button-elevated {
  background: linear-gradient(135deg, #F24368 0%, #E83258 100%);
  color: white !important;
  padding: 1rem 2rem !important;
  font-size: 1.1rem !important;
  box-shadow: 0 8px 20px rgba(242, 67, 104, 0.3);
  transition: all 0.3s ease;
}

.button-elevated:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(242, 67, 104, 0.4);
}

.button-secondary {
  background: white !important;
  color: #F24368 !important;
  border: 2px solid #F24368 !important;
  padding: 1rem 1.5rem !important;
}

// ヒーロー画像
.hero-image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.hero-image-bg {
  position: absolute;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(242, 67, 104, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(40px);
}

.hero-image {
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.1));
}

// お試しアップロードボタン
.trial-upload-wrapper {
  text-align: center;
  margin-top: 3rem;
}

.trial-upload-button {
  background: linear-gradient(135deg, #4974BB 0%, #3A5A9B 100%);
  color: white !important;
  padding: 1.2rem 2.5rem !important;
  box-shadow: 0 8px 20px rgba(73, 116, 187, 0.3);
  transition: all 0.3s ease;
  position: relative;
  min-height: 60px;
}

.trial-upload-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(73, 116, 187, 0.4);
}

.trial-upload-button .icon {
  margin-left: 0.5rem !important;
}

.trial-text {
  font-size: 1.1rem;
  font-weight: 700;
  display: block;
}

.trial-subtext {
  font-size: 0.8rem;
  opacity: 0.9;
  display: block;
  margin-top: 0.2rem;
}

// モバイル版スタイル
@media screen and (max-width: 768px) {
  // モバイル限定で上余白を追加
  #top {
    padding-top: 20px;
  }

  .hero {
    min-height: auto;
  }

  .hero-body {
    padding: 2rem 1rem;
  }

  .hero-content-mobile {
    text-align: center;
  }

  .hero-badge-mobile {
    display: inline-flex;
    align-items: center;
    background: rgba(242, 67, 104, 0.1);
    border: 1px solid rgba(242, 67, 104, 0.2);
    border-radius: 20px;
    padding: 0.4rem 0.8rem;
    margin-bottom: 1rem;
    font-size: 0.8rem;
  }

  .hero-image-wrapper-mobile {
    margin-bottom: 1.5rem;
  }

  .hero-image-mobile {
    max-width: 200px;
    height: auto;
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
  }

  .hero-title-text-mobile {
    font-size: 2rem;
    font-weight: 900;
    line-height: 1.2;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #18181B 0%, #18181B 40%, #F24368 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .hero-subtitle-mobile {
    font-size: 1rem;
    color: #666;
    margin-bottom: 1.5rem;
  }

  .stats-container-mobile {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }

  .stat-card-mobile {
    background: white;
    border-radius: 12px;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    flex: 1;
    max-width: 100px;
  }

  .stat-card-mobile .stat-number {
    font-size: 1.5rem;
    font-weight: 800;
    color: #F24368;
    margin-bottom: 0.3rem;
  }

  .stat-card-mobile .stat-label {
    font-size: 0.7rem;
    color: #666;
  }

  .hero-actions-mobile {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    align-items: center;
  }

  .button-elevated-mobile {
    background: linear-gradient(135deg, #F24368 0%, #E83258 100%);
    color: white !important;
    padding: 0.8rem 2rem !important;
    font-size: 1rem !important;
    box-shadow: 0 4px 15px rgba(242, 67, 104, 0.3);
    width: 200px;
  }

  .button-secondary-mobile {
    background: white !important;
    color: #F24368 !important;
    border: 2px solid #F24368 !important;
    padding: 0.8rem 1.5rem !important;
    width: 200px;
  }

  .trial-upload-wrapper {
    margin-top: 2rem;
  }

  .floating-circle {
    display: none;
  }

  .marquee-text-wrap {
    font-size: 12px;
  }

  .security-background {
    height: 300px
  }

  .dashboard-background {
    height: 300px
  }

  .title {
    font-size: 1.8rem
  }
}

@media screen and (min-width: 769px) {
  .marquee-text-wrap {
    font-size: 16px;
  }
}

@media screen and (min-width: 1921px) {
  .hero-body {
    padding-right: 20rem;
    padding-left: 20rem;
  }

  #tokutyou {
    padding: 5rem 50rem;
  }
}

@media screen and (min-width: 2559px) {
  .hero-body {
    padding-right: 40rem;
    padding-left: 40rem;
  }
}

.marquee-text-margin {
  margin-right: 60px
}

.section {
  background-color: transparent;
}

// https://angrytools.com/gradient/?0_EE3573,50_4974BB,100_F9B64D&r_90_50_50
svg.rainbow * {
  fill: url(#lgrad);
}

.tokutyou-number {
  font-size: 2.3rem;
}

.security-background {
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}

.dashboard-background {
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}

h2 {
  font-weight: 500 !important;
  color: var(--default-font-color);
  line-height: 2rem;
}

span.count {
  font-weight: bolder;
  font-size: x-large;
}

hr {
  height: 5px;
  border: none;
  width: 30px;
  text-align: center;
  display: inline-block;
  margin-top: 6px;
}

span.count {
  font-weight: bolder;
  font-size: x-large;
}

img.cm {
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}

.top-card-icon {
  margin: 12px 0;
}

.tile-card-direct {
  background-image: url(/static/images/top-card-direct.svg);
}

.tile-card-100gb {
  background-image: url(/static/images/top-card-100gb.svg);
  color: white;
}

.tile-card-infinite {
  background-image: url(/static/images/top-card-infinite.svg);
  color: white;
}

.tile-card-security {
  background-image: url(/static/images/top-card-security.svg);
  color: white;
}

.is-child-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

#tokutyou,
#features,
#blog {
  position: relative;
  z-index: 1;
}

.hero-stats {
  font-size: 0.9rem;
  color: #555;
}

.margin-left-12px {
  margin-left: 12px;
}

/* Benefits Section Styles */
.benefit-box {
  padding: 1.5rem;
  height: 100%;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 15px rgba(10, 10, 30, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.benefit-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(10, 10, 30, 0.1);
}

.benefit-icon {
  color: #F24368;
  margin-bottom: 1rem;
}

.benefit-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.8rem;
  color: var(--title-font-color);
}

/* CTA Banner Styles */
.cta-banner {
  background: linear-gradient(135deg, rgba(242, 67, 104, 0.9) 0%, rgba(73, 116, 187, 0.9) 100%);
  padding: 3rem 2rem;
  border-radius: 24px;
  margin: 0 1rem;
  color: white;
  text-align: center;
}

.cta-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.cta-text {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
}

.cta-buttons .button {
  min-width: 140px;
}

/* Testimonials Styles */
.testimonial-box {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 1.5rem;
  height: 100%;
  box-shadow: 0 2px 15px rgba(10, 10, 30, 0.05);
}

.testimonial-content {
  position: relative;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.testimonial-content::before {
  content: '"';
  font-size: 3rem;
  color: rgba(242, 67, 104, 0.2);
  position: absolute;
  top: -1.5rem;
  left: -0.5rem;
}

.testimonial-text {
  position: relative;
  z-index: 1;
}

.testimonial-author {
  display: flex;
  align-items: center;
}

.testimonial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 1rem;
  object-fit: cover;
}

.testimonial-name {
  font-weight: bold;
  margin-bottom: 0.2rem;
}

.testimonial-position {
  font-size: 0.9rem;
  color: #666;
}

/* FAQ Styles */
.faq-container {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  margin-bottom: 1rem;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.5rem;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.9);
  transition: background-color 0.3s ease;
}

.faq-question:hover {
  background-color: rgba(242, 67, 104, 0.05);
}

.faq-question h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: bold;
}

.faq-icon {
  font-size: 1.5rem;
  color: #F24368;
}

.faq-answer {
  padding: 0 1.5rem 1.5rem 1.5rem;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .hero-stats {
    font-size: 0.8rem;
  }

  .benefit-box {
    margin-bottom: 1rem;
  }

  .cta-banner {
    padding: 2rem 1rem;
  }

  .cta-title {
    font-size: 1.4rem;
  }

  .testimonial-box {
    margin-bottom: 1rem;
  }
}

// 追加のスタイル調整
.hero-stats {
  display: none; // 統計情報カードに置き換えたため非表示
}

// shimmer効果
.hover-shimmer {
  display: none; // 新しいデザインでは不要
}

// Hero内でのmargin調整（新レイアウト用）
@media screen and (min-width: 769px) {
  .hero-content {
    padding: 0 1rem;
  }
}

@media screen and (min-width: 1024px) {
  .hero-title-text {
    font-size: 3.2rem;
  }

  .hero-subtitle {
    font-size: 1.5rem;
  }

  .hero-content {
    padding: 0 2rem;
  }
}

@media screen and (min-width: 1920px) {
  .hero-content {
    padding: 0 2rem;
  }
}
</style>
